export default __webpack_public_path__ + "static/media/title2.c8403b64.png";